import React, { useState } from 'react'
import { Icon, Row, Spin } from 'antd'
import Dragger, { DraggerProps } from 'antd/lib/upload/Dragger'
import config from '../../../../config'

interface FileUpload {
	file: File
}

interface FileSelectorProps {
	sendFileForValidation: (file: File) => void
}

const FileSelector = ({ sendFileForValidation }: FileSelectorProps) => {
	const [isUploading, setIsUploading] = useState<boolean>(false)

	const draggerProps: DraggerProps = {
		name: 'file',
		multiple: false,
		accept: '.csv',
		showUploadList: false,
		customRequest: async ({ file }: FileUpload) => {
			setIsUploading(true)
			await sendFileForValidation(file)
			setIsUploading(false)
		}
	}

	return (
		<>
			<Row type='flex' justify='space-between'>
				<h3>Upload Subscriber Data</h3>
				<p>
					<a href={config.consumerTemplateUpdateUrl()}>(Download template)</a>
				</p>
			</Row>
			<Spin spinning={isUploading}>
				<Dragger {...draggerProps}>
					<p className='ant-upload-drag-icon'>
						<Icon type='inbox' />
					</p>
					<p className='ant-upload-text'>Click or drag file to this area to upload</p>
					<p className='ant-upload-hint'>
						Must be a CSV file in the provided template format. Your file will be validated and you will be given the option to review it before
						processing.
					</p>
				</Dragger>
			</Spin>
		</>
	)
}

export default FileSelector
